'use client';

import { c as _c } from "react/compiler-runtime";
import { useFormatter, useNow, useTranslations } from 'next-intl';
import { Suspense } from 'react';
import CreatorDescriptionReadMore from '@/app/[locale]/(worlds)/[roomId]/components/CreatorDescriptionReadMore';
import MarkdownDescription from '@/app/[locale]/(worlds)/[roomId]/components/MarkdownDescription';
import MarkdownDescriptionErrorBoundary from '@/app/[locale]/(worlds)/[roomId]/components/MarkdownDescriptionErrorBoundary';
import StaffDescription from '@/app/[locale]/(worlds)/[roomId]/components/StaffDescription';
import TextWithLinks from '@/components/TextWithLinks';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useMarkdownDescription } from '@/context/MarkdownDescriptionContext';
import { numberFormatter } from '@/lib/formatter';
const creatorDescriptionLinkProps = {
  className: 'text-vive-brand-40 underline transition-colors hover:text-vive-brand-50'
};
function WorldDescription() {
  const $ = _c(35);
  const t = useTranslations();
  const format = useFormatter();
  const now = useNow();
  const {
    roomData
  } = useCheckEnterRoomContext();
  let t0;
  if ($[0] !== roomData.description) {
    t0 = roomData.description?.trim();
    $[0] = roomData.description;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const staffDescription = t0;
  const markdownDescription = useMarkdownDescription();
  const creatorDescription = roomData.description_plaintext;
  let t1;
  if ($[2] !== format || $[3] !== now || $[4] !== roomData.create_time) {
    t1 = roomData.create_time ? format.relativeTime(new Date(roomData.create_time), now) : null;
    $[2] = format;
    $[3] = now;
    $[4] = roomData.create_time;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const relativeDate = t1;
  let plainTextDescription;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[6] !== creatorDescription || $[7] !== relativeDate || $[8] !== roomData.view_count || $[9] !== t) {
    const playsCount = numberFormatter(roomData.view_count);
    let t7;
    if ($[16] !== creatorDescription) {
      t7 = creatorDescription && <CreatorDescriptionReadMore content={<TextWithLinks text={creatorDescription} linkProps={creatorDescriptionLinkProps} />} />;
      $[16] = creatorDescription;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    plainTextDescription = t7;
    t4 = "world-description";
    t5 = "flex flex-col gap-1 lg:gap-2 lg:rounded-[15px] lg:bg-white/10 lg:px-6 lg:py-4 landscape:gap-1 landscape:rounded-none landscape:bg-transparent landscape:px-0 landscape:py-0";
    let t8;
    if ($[18] !== relativeDate) {
      t8 = relativeDate && <span className="subheader-2 whitespace-nowrap">{relativeDate}</span>;
      $[18] = relativeDate;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    t6 = <div className="hidden h-6 items-center gap-2 lg:flex landscape:hidden"><span className="subheader-2 whitespace-nowrap">{t("world-info.plays", {
          count: playsCount
        })}</span>{t8}</div>;
    t2 = "body-2 lg:hidden landscape:block";
    t3 = t("world-info.plays", {
      count: playsCount
    });
    $[6] = creatorDescription;
    $[7] = relativeDate;
    $[8] = roomData.view_count;
    $[9] = t;
    $[10] = plainTextDescription;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    plainTextDescription = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
  }
  let t7;
  if ($[20] !== t2 || $[21] !== t3) {
    t7 = <p className={t2}>{t3}</p>;
    $[20] = t2;
    $[21] = t3;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== staffDescription) {
    t8 = staffDescription && <StaffDescription description={staffDescription} />;
    $[23] = staffDescription;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== markdownDescription || $[26] !== plainTextDescription) {
    t9 = markdownDescription ? <MarkdownDescriptionErrorBoundary fallback={plainTextDescription}><Suspense fallback={plainTextDescription}><MarkdownDescription content={markdownDescription} /></Suspense></MarkdownDescriptionErrorBoundary> : plainTextDescription;
    $[25] = markdownDescription;
    $[26] = plainTextDescription;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
    t10 = <div data-component={t4} className={t5}>{t6}{t7}{t8}{t9}</div>;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
}
export default WorldDescription;